import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {H4} from "@irati/ui/src/Headings"
import Button from "@irati/ui/src/Button"

export const StyledH4 = styled(H4)`
  padding-top: 20px;
  padding-bottom: 30px;
`

export const StyledDiv = styled.div`
  max-width: 550px;
`

export const LeftAlign = styled.div`
  text-align: left;
`

export const MarginRightButton = styled(Button)`
  margin-right: ${padding.medium};
`
